
          import { ExposedComponents } from 'MdxComponents'
          export default {
            ...ExposedComponents
          }
        